import { createAction } from 'redux-actions';

import { listPublic as listChannelVideos } from 'widget/redux/server/actions/channel/videos/list-public';

import { DATA_KEY as PAGINATED_VIDEOS_KEY } from 'widget/data-components/paginated-channel-videos';


export const NAMES = {
  RESET: 'CLIENT.CHANNEL.PAGINATED_VIDEOS.RESET',
  UPDATE: 'CLIENT.CHANNEL.PAGINATED_VIDEOS.UPDATE',
};

const RESET = createAction(NAMES.RESET);
const UPDATE = createAction(NAMES.UPDATE);

const PRELOAD_PAGES = 2;

let currentUIPage = 0;
let channelId = null;
let nextPageOptions = {
  paging: {
    size: null,
    cursor: null,
  },
  query: null,
};

function saveNextPageCursor(response) {
  if (response) {
    nextPageOptions.paging.cursor = response.paging.cursor;
  }
}

export function goForward() {
  return function (dispatch, getState) {
    const { loadedUIPagesCount } = getState().lazyVideoLists[PAGINATED_VIDEOS_KEY];

    if (currentUIPage === loadedUIPagesCount - 1) {
      return;
    }

    currentUIPage += 1;

    if (loadedUIPagesCount - currentUIPage < PRELOAD_PAGES + 1 && nextPageOptions.paging.cursor) {
      dispatch(listChannelVideos(channelId, nextPageOptions)).then(saveNextPageCursor);
    }

    dispatch(UPDATE({ currentUIPage }));
  };
}

export function goBack() {
  return function (dispatch) {
    if (currentUIPage === 0) {
      return;
    }

    currentUIPage -= 1;
    dispatch(UPDATE({ currentUIPage }));
  };
}
export function toFirstPage() {
  return function (dispatch) {
    if (currentUIPage === 0) {
      return;
    }
    currentUIPage = 0;
    dispatch(UPDATE({ currentUIPage }));
  };
}

export function loadFirstPage(currentChannelId, { perUIPage, query, tag, category }) {
  return function (dispatch) {
    currentUIPage = 0;
    channelId = currentChannelId;
    dispatch(RESET({ currentUIPage, perUIPage }));

    nextPageOptions = {
      paging: {
        size: perUIPage * (PRELOAD_PAGES + 1),
        cursor: null,
      },
      query,
      tag,
      category,
    };

    return dispatch(listChannelVideos(channelId, nextPageOptions)).then(saveNextPageCursor);
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/paginated-channel-videos.js